module.exports = __webpack_public_path__ + "img/twitter_white_logo.f14ac3cc.png";